import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { SourcingInternalStoreComponent } from 'modules/sourcing-internal/stores/components/SourcingInternalStoreComponent';

export const AnalyseSourcingInternalCampaignSetupWithCandidateProfiles: React.FC =
  () => {
    const { getPathParams } = usePathsV2();
    const { sessionId } =
      getPathParams.ANALYSE_SOURCE_INTERNAL_CAMPAIGN_SETUP_WITH_CANDIDATE_PROFILES();

    return (
      <SourcingInternalStoreComponent
        sessionId={sessionId}
        initialCandidateBatchId={undefined}
      />
    );
  };
